import * as Sentry from "@sentry/react";

export interface SentryUser {
  id: string;
}

/** Attaches (or clears, with `null`) the current user on Sentry events. */
export function setSentryUser(user: SentryUser | null): void {
  Sentry.setUser(user);
}
